import { assignModalStyle } from "pages/PatientOverview/styles";
import { Box } from "@mui/system";
import { Divider, Grid } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useState } from "react";
import { ButtonColorScheme, ButtonType } from "types/ui";
import { Button } from "components/Buttons/Button";
import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentClinicTeamLeadsList } from "store/ClinicianStore/selectors";
import { Clinician } from "types/Clinician";
import { Popover } from "@material-ui/core";

type Props = {
  open: boolean;
  setOpen: any;
  anchorEl: HTMLElement | null;
  id: string;
  assignTeamLead: (teamLead: string | null) => void;
};

export const AssignModalBox = ({
  open,
  setOpen,
  anchorEl,
  id,
  assignTeamLead,
}: Props) => {
  const [personName, setPersonName] = useState<string[]>([]);
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const currentClinicTeamLeadsList: Clinician[] | undefined = useAppSelector(
    selectCurrentClinicTeamLeadsList
  );
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 300,
        width: 165,
        padding: 5,
      },
    },
  };

  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    const matchingLead: Clinician | undefined = currentClinicTeamLeadsList
      ?.slice()
      .find((e: Clinician) => {
        return (
          e?.profileInfo?.firstName + " " + e?.profileInfo?.lastName === value
        );
      });
    if (matchingLead) {
      setSelectedLeadId(matchingLead._id);
    }
    setPersonName(typeof value === "string" ? value.split(",") : value);
  };

  const handleOK = () => {
    assignTeamLead(selectedLeadId);
  };

  return (
    <div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        id={id}
        anchorOrigin={{
          vertical: 40,
          horizontal: -250,
        }}
      >
        <Box sx={assignModalStyle}>
          <Grid
            item
            xs={12}
            sx={{ fontWeight: "700", fontSize: 14, color: "#231F20" }}
            mt={1}
          >
            Assign a Team Lead
          </Grid>
          {currentClinicTeamLeadsList &&
          currentClinicTeamLeadsList.length > 0 ? (
            <FormControl sx={{ width: 250, maxHeight: 33, marginTop: 1 }}>
              <Select
                multiple={false}
                displayEmpty
                size="small"
                value={personName}
                onChange={(event) => handleChange(event)}
                input={<OutlinedInput />}
                inputProps={{ "aria-label": "Without label" }}
                MenuProps={MenuProps}
                renderValue={() => {
                  return (
                    <em>
                      {personName.length > 0 ? personName : "Select Lead"}
                    </em>
                  );
                }}
                sx={{ maxHeight: 33, fontSize: 12 }}
              >
                {currentClinicTeamLeadsList.map((clinician: Clinician) => (
                  <MenuItem
                    key={
                      clinician.profileInfo?.firstName +
                      " " +
                      clinician.profileInfo?.lastName
                    }
                    value={
                      clinician.profileInfo?.firstName +
                      " " +
                      clinician.profileInfo?.lastName
                    }
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "start",
                      fontSize: 13,
                      borderBottom: "1px solid #eee",
                      padding: "8px 16px",
                      wordWrap: "break-word",
                      wordBreak: "break-all",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {clinician.profileInfo?.firstName +
                      " " +
                      clinician.profileInfo?.lastName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Grid
              sx={{
                mt: 3,
                mb: 3,
                fontSize: 12,
                textAlign: "center",
                color: "#5C5D68",
                width: 165,
              }}
            >
              {"No team lead to select"}
            </Grid>
          )}

          <Divider sx={{ marginY: 1 }} />
          <Grid display="flex" justifyContent="space-between">
            <Grid
              item
              display="flex"
              alignItems={"center"}
              onClick={() => {
                setPersonName([]);
                setOpen(false);
              }}
              style={{
                color: "#9D9EA5",
              }}
            >
              Cancel
            </Grid>
            <Grid item display="flex" alignItems={"center"}>
              <Button
                title="OK"
                onClick={handleOK}
                type={ButtonType.normal}
                colorScheme={ButtonColorScheme.gradient}
                style={{
                  fontSize: "18px",
                  fontWeight: "400",
                  backgroundColor: "#05B2DC",
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Popover>
    </div>
  );
};
